import api from "@/config/api";

const path = "public/formular/employee/docket"

export default {

  get: (token) => {
    return api.get(`${path}/${token}`)
  },
  post: (docket, token) => {
    return api.post(path, docket, { params: { token } })
  }
}
